// extracted by mini-css-extract-plugin
export default {"mailcontainer":"Mail_mailcontainer__6T9wh","sidebar":"Mail_sidebar__6cuEU","content":"Mail_content__ja4g2"};